<sm-toolbar>
    <p-button icon="fas fa-run" label="Generieren" (onClick)="generateSmCode()"></p-button>
    <p-button  icon="fas fa-run" label="Zwischenablage -> Datei" (onClick)="smCodeClipToFile()"></p-button>
<!--       <p-button icon="fas fa-run" label="Screenshot -> Datei" (onClick)="smCodeScreenshotToFile()"></p-button>-->
</sm-toolbar>
<div class="width100p">
    <img [src]="smCodeBlob">
</div>
